var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiwaKeySoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Miwa_Key_Software"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Miwa_Key_Software",
    "data-name": "Miwa Key Software",
    clipPath: "url(#clip-Miwa_Key_Software)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "key_17456207",
    d: "M145.281,65.355H85.292a20,20,0,0,0-20,19.988v59.994a20.007,20.007,0,0,0,20,20h59.989a20,20,0,0,0,20.008-20V85.344A20,20,0,0,0,145.281,65.355Zm10.009,74.988a15.011,15.011,0,0,1-15,15h-50a15,15,0,0,1-14.989-15V90.353a14.992,14.992,0,0,1,14.989-15h50a15,15,0,0,1,15,15Zm-30.007-55a15,15,0,0,0-14.994,15,14.82,14.82,0,0,0,2.231,7.768L85.292,135.344l4.995,5,2.51-2.495,7.5,7.49,9.994-9.994-7.5-7.5,14.735-14.715a14.981,14.981,0,1,0,7.763-27.78Zm0,20a5,5,0,1,1,5.009-5A5,5,0,0,1,125.283,105.346Z",
    transform: "translate(-65.289 -65.355)",
    fill: "#e8eaf0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiwaKeySoftware);
export default __webpack_public_path__ + "static/media/miwa-key-software.1dd47c5200bcb6b6f404f4a6bc46d1ef.svg";
export { ForwardRef as ReactComponent };